export default __webpack_public_path__ + "static/media/char_body_004.05fbe691.png";